import axios from "axios";

export default {
  async getParametrage() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/parametrage"
    );
    return response.data;
  },
  async setParametrage(parametrage) {
    const response = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/parametrage",
      parametrage
    );
    return response.data;
  }
};
